import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { AuthService } from 'app/core/auth/auth.service';
import { from, of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Only redirect to sign-in if user is not already there
                    if (state.url.startsWith('/sign-in')) {
                        return of(false);
                    }

                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL =
                        state.url === '/sign-out' || state.url === '/' || state.url === ''
                            ? ''
                            : `redirectURL=${encodeURIComponent(state.url)}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                }

                // Authenticated — enforce first-login PIN reset if needed
                return from(Preferences.get({ key: 'needsPinReset' })).pipe(
                    switchMap(({ value }) => {
                        const needsPinReset = value === 'true';

                        // Force reset before anything else
                        if (needsPinReset && !state.url.startsWith('/set-pin')) {
                            return of(router.parseUrl('/set-pin'));
                        }

                        return of(true);
                    })
                );
            })
        );
};
